const buildEnv = {
  keycloak_realm: import.meta.env.VITE_KEYCLOAK_REALM,
  oauth_client_id: import.meta.env.VITE_OAUTH_CLIENT_ID,
  refresh_token_time: import.meta.env.VITE_REFRESH_TOKEN_TIME,
  idle_timeout: import.meta.env.VITE_IDLE_TIMEOUT,
  agreement_version: import.meta.env.VITE_AGREEMENT_VERSION,
  feature_whitelist: import.meta.env.VITE_FEATURE_WHITELIST,
  feature_subscriptions: import.meta.env.VITE_FEATURE_SUBSCRIPTIONS,
  feature_hdm_keys: import.meta.env.VITE_FEATURE_HDM_KEYS,
  feature_rbac: import.meta.env.VITE_FEATURE_RBAC,
  feature_end_user_messaging: import.meta.env.VITE_FEATURE_END_USER_MESSAGING,
  feature_phone_bonding: import.meta.env.VITE_FEATURE_PHONE_BONDING,
  feature_mdm: import.meta.env.VITE_FEATURE_MDM,
  feature_edge_lock: import.meta.env.VITE_FEATURE_EDGE_LOCK
}

function assignDefined(configEnv = {}, processEnv) {
  if (import.meta.env.DEV) {
    return processEnv;
  }
  Object.keys(configEnv).forEach((key) => {
    configEnv[key] = configEnv[key] ?? processEnv[key];
  });
  return configEnv;
}

export const getEnv = () => {
  
  const cmap = assignDefined(window.env, {
    keycloak_host: import.meta.env.VITE_KEYCLOAK_HOST,
    keycloak_issuer: import.meta.env.VITE_KEYCLOAK_ISSUER,
    oauth_redirect_uri: import.meta.env.VITE_REDIRECT_URL,
    graphql_endpoint: import.meta.env.VITE_GRAPHQL_ENDPOINT,
    keycloak_idp_hint: import.meta.env.VITE_KEYCLOAK_IDP_HINT,
    portal: import.meta.env.VITE_PORTAL
  });
  
  return {...buildEnv, ...cmap};
}
